<template>
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow" v-if="model">
        <div class="image-block">
            <div class="container" data-aos="fade-in">
                <NuxtLink :to="model.elements.link.value">
                    <NuxtImg class="img-fluid" v-if="firstOrDefault(model?.elements?.image?.value)" :src="model.elements.image.value[0]!.url" />
                    <div class="img-caption" :class="captionClass" v-if="model.elements.caption.value">
                        <p>{{ model.elements.caption.value }}</p>
                    </div>
                </NuxtLink>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { contentTypes, type ImageBlockModel } from '~~/app/models';
const type = contentTypes.image_block;
const props = defineProps<{ model: ImageBlockModel }>();

// light or dark, light as default
const captionClass = computed(() => firstOrDefault(props.model.elements.caption_styling.value)?.codename ?? 'light');
</script>